import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const ShapeDropFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M12.01 3.83008C6.75057 9.32691 5.91052 11.1166 5.91052 13.5454C5.91052 16.8143 8.70458 19.5901 12.01 19.5901C15.3154 19.5901 18.1094 16.8143 18.1094 13.5454C18.1094 11.1166 17.2694 9.32691 12.01 3.83008Z" />
    </SvgIcon>
  );
});
